import { useEffect } from 'react';
import usePrevious from 'react-use/esm/usePrevious';
import { useRecoilValue } from 'recoil';
import { useCurrentCaseId } from 'hooks/useCurrentCase';
import { rightDrawerCatalogRefreshSequenceState } from '../state';

type UseRightDrawerCatalogRefreshProps = {
  refetchTemplateItems: () => Promise<void>;
  refetchMacroItems: () => Promise<void>;
};

export const useRightDrawerCatalogRefresh = ({
  refetchTemplateItems,
  refetchMacroItems,
}: UseRightDrawerCatalogRefreshProps): void => {
  const currentCaseId = useCurrentCaseId();
  const previousCaseId = usePrevious(currentCaseId);
  const rightDrawerCatalogRefreshSequence = useRecoilValue(rightDrawerCatalogRefreshSequenceState);
  const previousCatalogRefreshSequence = usePrevious(rightDrawerCatalogRefreshSequence);

  useEffect(() => {
    if (currentCaseId == null || previousCaseId == null || previousCaseId === currentCaseId) {
      return;
    }

    void refetchTemplateItems();
    void refetchMacroItems();
  }, [currentCaseId, previousCaseId, refetchTemplateItems, refetchMacroItems]);

  useEffect(() => {
    if (
      previousCatalogRefreshSequence == null ||
      previousCatalogRefreshSequence === rightDrawerCatalogRefreshSequence
    ) {
      return;
    }

    void refetchTemplateItems();
    void refetchMacroItems();
  }, [
    previousCatalogRefreshSequence,
    rightDrawerCatalogRefreshSequence,
    refetchTemplateItems,
    refetchMacroItems,
  ]);
};
